export default {
  userClickedEditAndManageCodeButton: 'userClickedEditAndManageCodeButton',
  userClickedEmailCodeButton: 'userClickedEmailCodeButton',
  userViewedPostDownloadPage: 'userViewedPostDownloadPage',
  Flowcode_PostDownloadPage_Clicked_Analytics: 'Flowcode_PostDownloadPage_Clicked_Analytics',
  Flowcode_PostDownloadPage_Clicked_Analytics_Card:
    'Flowcode_PostDownloadPage_Clicked_Analytics_Card'
}
